/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebsocketEvent } from './WebsocketEvent';
import {
    WebsocketEventFromJSON,
    WebsocketEventFromJSONTyped,
    WebsocketEventToJSON,
    WebsocketEventToJSONTyped,
} from './WebsocketEvent';

/**
 * 
 * @export
 * @interface EmitWebsocketBody
 */
export interface EmitWebsocketBody {
    /**
     * 
     * @type {WebsocketEvent}
     * @memberof EmitWebsocketBody
     */
    event: WebsocketEvent;
    /**
     * 
     * @type {string}
     * @memberof EmitWebsocketBody
     */
    room?: string;
    /**
     * Can be any value - string, number, boolean, array or object.
     * @type {any}
     * @memberof EmitWebsocketBody
     */
    data?: any | null;
}



/**
 * Check if a given object implements the EmitWebsocketBody interface.
 */
export function instanceOfEmitWebsocketBody(value: object): value is EmitWebsocketBody {
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function EmitWebsocketBodyFromJSON(json: any): EmitWebsocketBody {
    return EmitWebsocketBodyFromJSONTyped(json, false);
}

export function EmitWebsocketBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmitWebsocketBody {
    if (json == null) {
        return json;
    }
    return {
        
        'event': WebsocketEventFromJSON(json['event']),
        'room': json['room'] == null ? undefined : json['room'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function EmitWebsocketBodyToJSON(json: any): EmitWebsocketBody {
    return EmitWebsocketBodyToJSONTyped(json, false);
}

export function EmitWebsocketBodyToJSONTyped(value?: EmitWebsocketBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': WebsocketEventToJSON(value['event']),
        'room': value['room'],
        'data': value['data'],
    };
}

